import React, {useEffect} from 'react';
import {trainCarInformation} from '../../services/trainsService';
import {SPECIAL_SEAT_TYPE} from '../../data/trainCarInformation';
import { crowdLevelForRate } from '../../data/crowdLevels';
import { freshCongestionCars } from '../../services/congestionService';
import icDirectionUp from '../../assets/images/mainline/train/detail/ic_direction_up.svg';
import icDirectionDown from '../../assets/images/mainline/train/detail/ic_direction_down.svg';

const header = (
  <div className="consist-header">
    <span className="consist-header-item car">号車</span>
    <div className="consist-header-inner">
      <span className="consist-header-item free-space">フリースペース</span>
      <span className="consist-header-item priority-seat">優先席</span>
      <span className="consist-header-item crowd-level">混雑度</span>
      <span className="consist-header-item car-status">他</span>
    </div>
  </div>
)

const directionIconUp = (
  <img src={icDirectionUp} className="consist-direction" width="48" height="24" alt="進行方向" />
);

const directionIconDown = (
  <img src={icDirectionDown} className="consist-direction" width="48" height="24" alt="進行方向" />
);

const noteRow = (
  <div className="consist-note">
    <div className="consist-legend">
      <span className="consist-legend-item free-space">フリースペース</span>
      <span className="consist-legend-item priority-seat">優先席</span>
    </div>
    <ul className="consist-note-list">
      <li className="consist-note-item">混雑度は約5分前の情報です</li>
      <li className="consist-note-item">
        女性専用車は、平日の一部時間帯のみ運用<br />
        <a href="https://www.mir.co.jp/service/other/woman.html?exbrowser=1" className="consist-link">詳細はこちら</a>
      </li>
      <li className="consist-note-item">
        非常通報器のご案内。
        <a href="https://www.mir.co.jp/service/guide/post_15.html?exbrowser=1" className="consist-link">詳細はこちら</a>
      </li>
    </ul>
  </div>
)

const specialSeatMark = (seatType) => {
  switch (seatType) {
    case SPECIAL_SEAT_TYPE.freeSpace:
      return <span className="consist-free-space-mark"></span>;
    case SPECIAL_SEAT_TYPE.prioritySeat:
      return <span className="consist-priority-seat-mark"></span>;
    default:
      return null;
  }
}

const carRow = (carInfomation, congestionRate) => {
  const crowdLevel = congestionRate !== null ? crowdLevelForRate(congestionRate) : null;

  return (
    <li className="consist-row" key={carInfomation.number}>
      <div className="consist-car">
        <div className="consist-car-body">
          <p className="consist-car-number">{carInfomation.number}</p>
          <div className="consist-seat-slot">{carInfomation.specialSeats[0] ? specialSeatMark(carInfomation.specialSeats[0]) : null}</div>
          <div className="consist-seat-slot">{carInfomation.specialSeats[1] ? specialSeatMark(carInfomation.specialSeats[1]) : null}</div>
          <div className="consist-seat-slot">{carInfomation.specialSeats[2] ? specialSeatMark(carInfomation.specialSeats[2]) : null}</div>
          <div className="consist-seat-slot">{carInfomation.specialSeats[3] ? specialSeatMark(carInfomation.specialSeats[3]) : null}</div>
        </div>
      </div>
      <div className="consist-info-container">
        <div className="consist-free-space">
          {carInfomation.freeSpaceDoorNumbers && carInfomation.freeSpaceDoorNumbers.length > 0 ? (
            <React.Fragment>
              <span className="consist-door-number">{carInfomation.freeSpaceDoorNumbers.join()}</span><span className="consist-door-label">番ドア</span>
            </React.Fragment>
          ) : (
            <span className="consist-door-number">-</span>
          )}
        </div>
        <div className="consist-priority-seat">
          {carInfomation.prioritySeatDoorNumbers && carInfomation.prioritySeatDoorNumbers.length > 0 ? (
            <React.Fragment>
              <span className="consist-door-number">{carInfomation.prioritySeatDoorNumbers.join()}</span><span className="consist-door-label">番ドア</span>
            </React.Fragment>
          ) : (
            <span className="consist-door-number">-</span>
          )}
        </div>
        <div className="consist-crowd-level">
          {crowdLevel ? (
            <img src={crowdLevel.icon} className="consist-crowd-level-icon" />
          ) : (
            <span className="consist-crowd-level-non" />
          )}
        </div>
        <div className="consist-car-status">
          {carInfomation.number == 3 ? (
            <span className="consist-mild-cooling">弱冷車</span>
            ) : null}
          {carInfomation.number == 1 ? (
            <span className="consist-women-only">女性専用車</span>
          ) : null}
        </div>
      </div>
    </li>
  )
}

const TrainConsist = ({ train, congestions }) => {
  useEffect(() => {
    import('../../assets/stylesheets/mainline/trains/consist_panel.css')
      .then(() => {
      })
      .catch(err => console.error("CSSの読み込みエラー", err));
  }, []);

  const freshCongestions = freshCongestionCars(congestions);
  const carRows = trainCarInformation(train).informations.map( car => {
    const congestion = freshCongestions.find(c => c.car === car.number);
    return carRow(car, congestion ? congestion.congestion_rate : null);
  });

  return (
    <div className="consist">
      {header}
      <div className="consist-body">
        <ul className="consist-list">
          <li className="consist-row">
            <div className="consist-car">
              {train.direction == 'up' ? directionIconUp : null}
            </div>
            <div className="consist-info-container"></div>
          </li>
          {carRows}
          <li className="consist-row">
            <div className="consist-car">
              {train.direction == 'down' ? directionIconDown : null}
            </div>
            {noteRow}
          </li>
        </ul>
      </div>
    </div>
  )
}

export default TrainConsist